import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import type { AnalyticsResponse, ReportListResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetReports(): Observable<ReportListResponse[]> {
    return this.http
      .get(`${environment.BASE_URL}/reports`, {
        headers: this.httpOptions.headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkAsFevouriteReport(reportkey: string): Observable<Response> {
    return this.http
      .post(`${environment.BASE_URL}/reports/${reportkey}/add_favourite`, {
        headers: this.httpOptions.headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  RemoveFromFevouriteReport(reportkey: string): Observable<Response> {
    return this.http
      .post(`${environment.BASE_URL}/reports/${reportkey}/remove_favourite`, {
        headers: this.httpOptions.headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetAnalytics(allParams:Array<string>=[]): Observable<AnalyticsResponse> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http.get<AnalyticsResponse>(environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_TOTAL_SALES_AND_PAYMENTS, {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }
}
